<template>
	<div class="ptrl-18-16 box-s" :class="{'pb-30': padShow }" id="nodes">
			<div v-for="(item, index) in list" :key="index">
				<div class="quest_header flexs mb-22" v-if="qusetNum == (index + 1)">
					<div class="c1 fz-16"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>

					<div v-if="item.question_type == 1" class="tag_class mt-12 ml-5 bg_ff c13">单选题</div>
					<div v-if="item.question_type == 2" class="tag_class mt-12 ml-5 bg_dc c12">多选题</div>
					<div v-if="item.question_type == 3" class="tag_class mt-12 ml-5 bg_ea c11">判断题</div>
				</div>
				<div class="fz-14 fw-500 c1 mb-22" v-if="qusetNum == (index + 1) && item.question_stem" v-html="item.question_stem"></div>
				<!-- 单选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 1)">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer[0] === Object.keys(innerItem)[0] }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getRadios(Object.keys(innerItem)[0])" >
						<div class="">{{Object.keys(innerItem)[0]}}.</div>
						<div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
					</li>
				</ul>

				<!-- 判断题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 3)">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer === 'true' }" @click="getDecide('true', item)" >
						<div class="">A.</div>
						<div class="ml-6" >正确</div>
					</li>

					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer === 'false' }" @click="getDecide('false', item)" >
						<div class="">B.</div>
						<div class="ml-6" >错误</div>
					</li>
				</ul>
				

				<!-- 多选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && item.question_type == 2">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'tag_active': form[index].answer.indexOf(Object.keys(innerItem)[0]) != -1 }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getCheckBox(Object.keys(innerItem)[0])" >
						<div class="">{{Object.keys(innerItem)[0]}}.</div>
						<div class="ml-6 nodes" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
					</li>
				</ul>
			</div>
    <loading :loadFlag="loadFlag"></loading>
    <qusetBottom :length="length" :questBtn="questBtn" :cData="cData" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" ></qusetBottom>
	</div>
</template>
<script>
  
	import { startDailyStudy  } from '@/api/api'
	import {getShowPadding} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import loading from "@/components/loading"
	export default {
		components: {
      qusetBottom,
			loading
		},
		data() {
			return {
				length: 0,//题目数量
				padShow: false, //是否展示底部30padding
				list: [], //每一页的题数据
				qusetNum: 1, //第几道题
				form: [], //提交数据
        		number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],
				collectFalg: false, //是否收藏
				cData:{
					model_type: 1,
					question_id: '',
					way: 2,
					base_id: ''
				},
				loadFlag: false,
				questBtn: true
			};
		},
		created() {
			this.cData.base_id = this.$route.query.id
			this.qusetNum = this.$route.query.qusetNum? Number(this.$route.query.qusetNum):1
			this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
			async initData(){
				this.loadFlag = true
        		const res = await startDailyStudy({ id: this.$route.query.id })
				this.loadFlag = false
				if(res.code == 1000){
          			this.list = res.data.data
					this.length = this.list.length
          			this.dailyStudyId = res.data.dailyStudyId

					this.cData.question_id = this.list[this.qusetNum - 1].id
					// 收藏错题状态
          			this.collectFalg = this.list[this.qusetNum - 1].answer_wrong_id? true : false
          
					// 需要提交的数据
					this.form = this.$route.query.form? JSON.parse(this.$route.query.form) : this.list.map(item => {
						let i = { "question_id": item.id, question_type: item.question_type }
						i.answer = item.question_type == 2? [] : ''
						return i
					})
				} else if(res.code == 10001){
					this.$toast(res.msg)
					setTimeout(()=>{
            		this.$router.replace('/practicelist')
					}, 1000)
				} else {
					this.$toast(res.msg)
				}
			},

			// 单选题切换
			getRadios(data){
				this.form[this.qusetNum - 1].answer = [data]
			},
      
			// 判断题切换
			getDecide(data, item){
				this.form[this.qusetNum - 1].answer = data
			},
      
			// 多选题切换
			getCheckBox(data){
        this.form[this.qusetNum - 1].answer.indexOf(data) == -1?this.form[this.qusetNum - 1].answer.push(data):this.form[this.qusetNum - 1].answer.splice(this.form[this.qusetNum - 1].answer.indexOf(data), 1)
			},

			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(type == '1'){
          this.qusetNum -= 1
				} else if (type == '2') {
          this.qusetNum += 1
				}
        this.cData.question_id = this.list[this.qusetNum - 1].id
				this.collectFalg = this.list[this.qusetNum - 1].answer_wrong_id? true : false
			},

			// 收藏
			collect(collectFalg){
        this.collectFalg = !collectFalg
				this.list[this.qusetNum - 1].answer_wrong_id = this.collectFalg? 1: 0
			},

			
			// 查看答题卡
			quertCard(type){
				const form = JSON.stringify(this.form)
        this.$router.replace({path: '/card', query:{form, id: this.$route.query.id, dailyStudyId: this.dailyStudyId } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}
</style>
<style>
#nodes img{
  max-width: 100%;
  width: auto!important;
  display: inline-block;
}
</style>
